module.exports = __webpack_public_path__ + "img/left.87dd7c95.png";